/**
 * WidgetBoundary — a per-widget error boundary so one malformed card can never
 * take down the message (or the chat). On any render error it swallows the widget
 * and renders nothing, matching the "degrade, never throw" contract. Error
 * boundaries must be class components in React.
 */
import React from 'react'

interface Props {
  children: React.ReactNode
}
interface State {
  failed: boolean
}

class WidgetBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { failed: false }
  }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(): void {
    // intentionally silent — a single bad widget is a soft failure, not a chat crash
  }

  render(): React.ReactNode {
    if (this.state.failed) return null
    return this.props.children
  }
}

export default WidgetBoundary
